import styled from 'styled-components'
import { ServerFileUtils } from '../utils/server/ServerFileUtils'

const B2bContainer = styled.div`
  display: flex;
  width: 100vw;
  height: 100vh;
`
const B2bIframe = styled.iframe`
  border: none;
  flex: auto;
`
const B2b = ({ b2bPath }: { b2bPath: string }) => {
  return (
    <B2bContainer>
      <B2bIframe src={b2bPath} />
    </B2bContainer>
  )
}
export default B2b
export const getStaticProps = async () => {
  let b2bPath = 'https://b2b.reshet.tv/'
  try {
    const response = (await ServerFileUtils.readJsonFile({
      filePath: './public/cdn/b2b.json',
    })) as { success: boolean; data: { b2bPath: string } }

    if (response.success) {
      b2bPath = response.data.b2bPath
    }
  } catch (e) {
    console.log('b2b: 30', { m: 'missing b2b path file' })
  }
  return {
    props: {
      b2bPath,
    },
    revalidate: 120,
  }
}
